export default "__VITE_ASSET__7212e50b__"